"use client";

import { Suspense } from "react";
import DataTabs from "@/components/DataTabs";

export default function DojiPage() {
  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>
        <DataTabs initialTab="doji" showTabBar={false} />
      </Suspense>
    </main>
  );
}
